module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAAAXNSR0IArs4c6QAAATRJREFUSEvt1r8rxWEUx/HXTRj8SFiU1WIxSDFIMlkMFhYRSSnJqKRkM1mkTBgZjDZZ8E8YLIwGMdC96Ll9bz19uzffe92NM36ec97P+Z7nnNM3p7yt4AANFc7T8jEW8RUf5CoEP+MFOyj8cMEMJjGKmyzwkMEhVjNkPoZrLOAkDe9ASyQG8CPCp25lgA/hAhs4j/zzoSzvaMoAqdolwPcQsq+3FSo9aF0uSsPDA3ZhN6LPoh/bkTaFCaxH2jimsVbS0vA7DCPWrxJ4L/JJ4BGWU36hAebRirfgl4bfYuQf/l+W0Bx/rFvOMIg+fCZDtI8ltEUTWlNZOtGOhwgUFl037n8Lz7rEasq8Wngo1Wu53XKKOWziKSsVjckmbU62ajE0PaEDuERPFeCS6wfCX0MoT9G+AYsGZcX+2OwMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/del.png
// module id = JFjG
// module chunks = 1